<template>
  <div class="ds-control dsf_teas_assess_list mobile" :class="[isDesign?'mr_mobile_class':'']">
    <div v-for="(items, key, indexs) in tableData" :key="indexs" class="assess_list">
      <div class="teas-assess-title" v-if="showTitle">
        <span></span>
        {{ items[0].formModel ? items[0].formModel.projectName : caption }}
      </div>
      <div class="rank-box" v-for="(item, index) of items" :key="index" :style="index==items.length-1?'border:none;':''">
        <div class="rank-project rank-project-team" v-if="showProject && item.projectTeam!==item.project && !item.hierarchy ">{{item.projectTeam}}</div>
        <p class="rank-project" v-if="item.project">  <span>*</span> {{ item.project }}</p>
        <p class="rank-norm" v-if="item.formModel?item.formModel.norm:item.standard">
          评分标准：{{ item.standard }}
        </p>
        <div class="rank-score">
          <!-- 混合模式 -->
          <div class="score-box" v-if="!item.scoringModeForm || !item.scoringModeForm.checkPattern" >
            <template v-if="!item.scoringModeForm || !item.scoringModeForm.blendSelect">
              <van-button type="default" :disabled="checkRendOnly(item.formModel)" @click="getPickerValue(86, 100, item, 'excellent', key,'',index)" :class="[item.excellentValue ? 'selectBtn' : '']">
                {{ item.excellentValue || "优秀" }}
              </van-button>
              <van-button type="default" :disabled="checkRendOnly(item.formModel)" @click="getPickerValue(76, 85, item, 'fine', key,'',index)" :class="[item.fineValue ? 'selectBtn' : '']">
                {{ item.fineValue || "良好" }}
              </van-button>
              <van-button type="default" :disabled="checkRendOnly(item.formModel)" @click="getPickerValue(60, 75, item, 'commonly', key,'',index)" :class="[item.commonlyValue ? 'selectBtn' : '']">
                {{ item.commonlyValue || "一般" }}
              </van-button>
              <van-button type="default" :disabled="checkRendOnly(item.formModel)" @click="getPickerValue(0, 59, item, 'difference', key,'',index)" :class="[item.differenceValue != null ? 'selectBtn' : '']">
                {{ item.differenceValue != null ? item.differenceValue : "差" }}
              </van-button>
            </template>
            <template v-else>
              <van-button
                type="default"
                v-for="(ite, inde) of item.scoringModeForm.customBlendTable"
                :key="inde"
                :disabled="checkRendOnly(item.formModel)"
                @click="
                  getPickerValue(
                    ite.blendMinNumber,
                    ite.blendMaxNumber,
                    item,
                    'customBlend',
                    key,
                    inde
                    ,index
                  )
                "
                :class="[ite.blendValue != null ? 'selectBtn' : '']">
                {{ ite.blendValue != null ? ite.blendValue : ite.blendName }}
              </van-button>
            </template>
          </div>
          <!-- 滑块模式  普通-->
          <div
            class="score-box"
            v-if="
              item.scoringModeForm &&
                item.scoringModeForm.checkPattern == 1 &&
                !item.scoringModeForm.pattern
            ">
            <div class="slider-box">
              <p>评分</p>
              <div>
                <van-slider v-model="item.sliderValue" @change="setValue" bar-height="4px" :min="item.scoringModeForm.hkMinNumber" :max="item.scoringModeForm.hkMaxNumber" :step="item.scoringModeForm.steps" active-color="#ee0a24" :disabled="checkRendOnly(item.formModel)">
                  <template #button>
                    <div class="custom-button">{{ item.sliderValue }}</div>
                  </template>
                </van-slider>
              </div>
            </div>
          </div>
          <!-- 滑块模式 特殊 -->
          <div
            class="score-box"
            v-if="
              item.scoringModeForm &&
                item.scoringModeForm.checkPattern == 1 &&
                item.scoringModeForm.pattern
            ">
            <div class="slider-box">
              <p>评分</p>
              <div>
                <van-rate
                  v-model="item.sliderValue"
                  @change="setValue"
                  :disabled="checkRendOnly(item.formModel)"
                  :icon="`icon iconfont ${
                    sliderIconArr[item.scoringModeForm.hkIcon].selectIcon
                  }`"
                  :void-icon="`icon iconfont ${
                    sliderIconArr[item.scoringModeForm.hkIcon].defaultIcon
                  }`"
                  :allow-half="item.scoringModeForm.hkStep == 1"
                  color="#fadb14" />
              </div>
            </div>
          </div>
          <!-- 数字模式 -->
          <div
            class="score-box"
            v-if="
              item.scoringModeForm && item.scoringModeForm.checkPattern == 2
            ">
            <van-cell-group :border="false">
              <van-field v-model="item.numberValue" type="number" @change="setValue" :disabled="checkRendOnly(item.formModel)" label="评分" :error-message="numberTips(item)" :placeholder="`请输入${item.scoringModeForm.textMinNumber}-${item.scoringModeForm.textMaxNumber}之间的分数`" />
            </van-cell-group>
          </div>
          <!-- 选项模式 -->
          <div
            class="score-box"
            v-if="
              item.scoringModeForm && item.scoringModeForm.checkPattern == 3
            ">
            <div class="optionBox">
              <div class="opationValue" v-for="(ite, indx) of item.scoringModeForm.selectTableData" :key="indx" @click="optionChange(item, key, indx,index)" :class="[item.optionValue == indx ? 'optionSet' : '']">
                <i v-if="item.scoringModeForm.choiceIcon" :class="['iconfont', ite.icon]"></i>
                {{ ite.content }}
              </div>
            </div>
          </div>
          <!-- 下拉模式-->
          <div
            class="score-box"
            v-if="
              item.scoringModeForm && item.scoringModeForm.checkPattern == 4
            ">
            <div class="drop-box">
              <p>评分</p>
              <div
                @click="
                  getPickerValue(
                    0,
                    item.scoringModeForm.dropNumber,
                    item,
                    'drop',
                    key,
                    '',
                    index
                  )
                ">
                <span>
                  {{ item.dropValue != null ? item.dropValue : "选择项" }}</span>
                <van-icon name="arrow-down" />
              </div>
            </div>
          </div>
          <p class="tipsInfo" v-if="item.errTips">此项必填</p>
        </div>
      </div>
      <div class="assess-total" v-if="showTotal">
        <span class="total-span">总分: </span>
        <div class="total-score">
          <span>{{ totalValue[key] ? totalValue[key].toFixed(2) : 0.00 }}</span>
          <i class="iconfont icon-a-icon-grade"></i>
        </div>
      </div>
    </div>
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" />
    </van-popup>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfMobileTeasAssessList",
  ctrlCaption: "评价组件",
  mixins: [$mixins.rankControl],
  design: {
    isMask: false,
  },
  props: {},
  data() {
    return {
      columns: [],
      showPicker: false,
      sliderValue: 0,
      //  混合模式
      currentRow: {},
      currentKey: "",
      currentType: "",
      currentIndex: 0,
      //   自定义混合
      customBlendIndex: "",
      customBlendValue: 0,
      //   滑块模式图标
      sliderIconArr: [
        {
          selectIcon: "icon-icon_star_active",
          defaultIcon: "icon-icon_star_normal",
          title: "五角星",
        },
        {
          selectIcon: "icon-icon_emoji_fine2",
          defaultIcon: "icon-icon_emoji_general",
          title: "笑脸",
        },
      ],
    };
  },
  computed: {},
  components: {},
  watch: {},
  mounted() { },
  created() { },
  methods: {
    numberTips(v) {
      if (v.numberValue == "") return;
      let max = Number(v.scoringModeForm.textMaxNumber);
      let min = Number(v.scoringModeForm.textMinNumber);
      let value = Number(v.numberValue);
      if (value >= min && value <= max) {
        return;
      } else if (v.numberValue != null) {
        return `请输入${min}-${max}之间的分数`;
      }
    },
    // 获取picker值
    getPickerValue(min, max, item, type, key, inde, index) {
      if (this.isDesign) return;
      console.log(item.formModel);
      if (this.checkRendOnly(item.formModel)) return;
      let minValue = Number(min);
      let maxValue = Number(max);
      this.showPicker = true;
      this.columns = [];
      this.currentRow = item;
      this.currentKey = key;
      this.currentType = type;
      this.currentIndex = index;
      if (inde !== "") {
        this.customBlendIndex = inde;
      }

      for (let index = maxValue; index >= minValue; index--) {
        this.columns.push(index);
      }
    },
    // 确认传值
    onConfirm(value, index) {
      var { currentIndex, currentKey } = this;
      var tableData = this.tableData[currentKey][
        currentIndex
      ];
      if (this.currentType == "excellent") {
        tableData.excellentValue = value;
        tableData.fineValue = null;
        tableData.commonlyValue = null;
        tableData.differenceValue = null;
      } else if (this.currentType == "fine") {
        tableData.excellentValue = null;
        tableData.fineValue = value;
        tableData.commonlyValue = null;
        tableData.differenceValue = null;
      } else if (this.currentType == "commonly") {
        tableData.excellentValue = null;
        tableData.fineValue = null;
        tableData.commonlyValue = value;
        tableData.differenceValue = null;
      } else if (this.currentType == "difference") {
        tableData.excellentValue = null;
        tableData.fineValue = null;
        tableData.commonlyValue = null;
        tableData.differenceValue = value;
      } else if (this.currentType == "customBlend") {
        tableData.scoringModeForm.customBlendTable.map((ite, i) => {
          if (i !== this.customBlendIndex) {
            ite.blendValue = null;
          } else {
            ite.blendValue = value;
            this.customBlendValue = value;
          }
          return ite;
        });
      } else if (this.currentType == "drop") {
        tableData.dropValue =
          value;
      }
      this.setValue();
      this.showPicker = false;
    },
    // 选项模式
    optionChange(row, key, indx, index) {
      if (this.checkRendOnly(row.formModel)) return
      this.tableData[key][index].optionValue = indx;
      this.setValue();
    },
    $formItemInnerValidate() {
      //组件内部校验结果
      let errors = [];
      for (const key in this.tableData) {
        if (Object.hasOwnProperty.call(this.tableData, key)) {
          const element = this.tableData[key];
          // 对象方法归类
          let elementObj = {};
          element.map((ite) => {
            let key = ite.formModel ? ite.formModel.projectKey : this.caption;
            if (!elementObj[key]) elementObj[key] = {};
            elementObj[key][ite.customID] = ite;
          });
          let total = 0;
          // 检查score循环
          this.checkValue.map((val, i) => {
            let elementItem = elementObj?.[val.data_sign]?.[val.item];
            let required = true;
            if (!this.required) {
              required = false;
            } else {
              required =
                elementItem && elementItem.formModel
                  ? elementItem.formModel.required
                  : this.required;
            }
            if (required) {
              if (val.score == null) {
                if (elementItem) {
                  elementItem.errTips = true;
                  errors.push({
                    target: this.$el,
                    message: `第${i}项分数为必填`,
                  });
                }
              } else {
                if (elementItem) {
                  total += val.score;
                  elementItem.errTips = false;
                }
              }
              if (elementItem) {
                let totalWeight = elementItem.formModel
                  ? elementItem.formModel.totalWeight
                  : 100;
                let calcScore = elementItem.formModel
                  ? elementItem.formModel.calcScore
                  : false;
                if (total != Number(totalWeight) && calcScore) {
                  this.$message("总分必须达到" + totalWeight + "分", false);
                  errors.push({
                    target: this.$el,
                    message: `总分必须达到${totalWeight}分`,
                  });
                }
              }
            }
          });
        }
      }
      // 定位错误位置
      setTimeout(() => {
        this.$nextTick(() => {
          let tips = $(this.$el)
            .find(".tipsInfo")
            .eq(0)
            .parents(".rank-box")[0];
          if (tips) {
            tips.scrollIntoView();
          }
        });
      }, 0);
      return errors;
    },
  },
});
</script>
